import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/account/:portalPage?",
    name: "Account",
    component: () => import("./portalLandingPage.vue"),
    props: true,
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("./cwLogin.vue"),
  },
  {
    path: "/forgot-password/:token?",
    name: "Forgot Password",
    component: () => import("./forgotPassword.vue"),
  },
] satisfies RouteRecordRaw[];
